function calculatePriceWithModifiers(menuItem, selectedModifiers) {
  const hasMenuItemGroups = menuItem.itemGroups;

  let price = hasMenuItemGroups
    ? 0
    : menuItem.price;

  let allModifiers = [];

  menuItem.modifierGroups.forEach((group) => {
    allModifiers = allModifiers.concat(group.modifiers);
  });

  // If a menuItem has `itemGroups` it is considered a "dynamic" menu item, where it's modifier groups are dynamically rendered based on a top-level
  // modifier item selection. Example: A large sandwich if selected might have different dynamically rendered modifier groups compared to a med or small.
  // If true, a complete list of all available modifier's must be constructed from each of the itemGroups.modifiers and the menuItems.modifierGroups
  // to find a match in order to add a modifiers price to the sum total of all selected modifiers.
  if (hasMenuItemGroups) {
    const menuItemGroups = Object.values(menuItem.itemGroups);

    menuItemGroups.forEach((itemGroup) => {
      itemGroup.forEach((group) => {
        if (group.modifiers) {
          allModifiers = allModifiers.concat(group.modifiers);
        }
      });
    });
  }

  selectedModifiers.forEach((m) => {
    const modifier = allModifiers.find(mod => mod.menuItemId === m.menuItemId);

    if (modifier) {
      if (m.modifiers) {
        price += calculatePriceWithModifiers(modifier, m.modifiers);
      }

      else if (m.modifierPriceOverride) {
        price += m.modifierPriceOverride;
      }

      else {
        price += (modifier.price * m.quantity);
      }
    }
  });

  return price;
}


export default calculatePriceWithModifiers;
